// extracted by mini-css-extract-plugin
export default {"HomeCard":"style_HomeCard__5mvbt","info":"style_info__OZJx0","content":"style_content__qalxf","title":"style_title__sKziY","icon":"style_icon__4AOv1","arrow":"style_arrow__qvxVu"};